import React from 'react';
import Formsy from 'formsy-react';
import FormsySimpleInput from '../../form/FormsySimpleInput';
import withOnboarding from '../withOnboarding';
import ChefAvailabilityCal from '../../chef/ChefAvailability';
import { ChefAvailabilityContext } from '../../chef/ChefAvailabilityContext';

class ChefAvailability extends React.Component {
  state = {
    chef_availabilities: []
  };

  render() {
    return (
      <div className="on-boarding__step on-boarding_step--chef">
        <div className="on-boarding__wrap on-boarding__wrap--chef-locations">
          <h1 className="on-boarding__h1">When are you available?</h1>
          <p className="on-boarding__p">
            Select blocks to represent your availability. Keep in mind that each
            cooking visit takes about 4-5 hours including grocery shopping.
          </p>

          <div className="on-boarding__chef-availability">
            <ChefAvailabilityContext.Provider value={this.state}>
              <ChefAvailabilityCal
                className="chef-availability-calendar chef-availability-calendar--onboarding"
                isMobile={this.props.isMobile}
                availabilities={this.state.chef_availabilities}
                updateChef={this.updateChef}
                isEdit={true}
              />
            </ChefAvailabilityContext.Provider>
          </div>

          <Formsy
            onValidSubmit={this.handleSubmit}
            onInvalidSubmit={this.handleInvalidSubmit}
            onValid={this.handleValid}
            onInvalid={this.handleInvalid}
          >
            <FormsySimpleInput
              type="hidden"
              name="total_availabilities"
              value={this.state.chef_availabilities.length}
              validations="isGreaterThan:0"
            />
            <FormsySimpleInput
              type="hidden"
              name="all_forms_valid"
              value={this.props.actions.isValid('submit')}
              validations="isTrue"
            />
            <input
              ref={this.props.actions.assignTrigger}
              type="submit"
              hidden
            />
          </Formsy>
        </div>
      </div>
    );
  }

  updateChef = ({ chef_availabilities }) =>
    this.setState({ chef_availabilities });

  // handleChange = (e) => {
  //   this.setState({[e.target.name]: e.target.value});
  // };

  handleInvalidSubmit = () => console.log('failed submit');

  handleValid = () => this.props.actions.setValidState('main', true);
  handleInvalid = () => this.props.actions.setValidState('main', false);

  // this will be triggered from the ChefOnboarding component
  handleSubmit = (formData, data, errors) => {
    const { chef_availabilities } = this.state;
    // update chef
    const updatedChef = { chef_availabilities };
    this.props.updateChef(updatedChef);
    this.props.actions.markComplete(this.props.step);
  };

  deriveState() {
    const { chef_availabilities = [] } = this.props.chef;
    this.setState({ chef_availabilities });
  }

  componentDidMount() {
    // handle resets here
    const reset = this.props.resets.includes(this.props.step);

    if (reset) this.reset();

    this.deriveState();
  }
}

export default withOnboarding(ChefAvailability);



// WEBPACK FOOTER //
// ./src/components/onboarding/chef/ChefAvailability.js